import { z } from 'zod';
import { AnalyticsSupportedSocialMediaType } from '@anytag/shared-types';

export const AnalyticsAccountParamsSchema = z.object({
  socialMedia: z.nativeEnum(AnalyticsSupportedSocialMediaType),
  brandAccountId: z.string(),
  socialMediaAccountId: z.string()
});
export type AnalyticsAccountParamsSchemaType = z.infer<typeof AnalyticsAccountParamsSchema>;
